import { useAppSelector } from 'src/app/reduxCustomHooks';
import type { DemoSourceRo } from 'src/app/services/api.generated';

/** Source labels of the demo user's counted upload, memory only (auth.demoSource). */
export const useDemoSource = (): DemoSourceRo | null => useAppSelector((state) => state.auth.demoSource);
